module.exports = __webpack_public_path__ + "static/img/card_bg.b7f0eeda.png";